import { Routes } from '@angular/router';
import { RECOGNITION_ROUTES } from '../../../object-detection/object-detection.routes';
import { PagesWrapperComponent } from './pages-wrapper.component';

export const WRAPPER_ROUTES: Routes = [
  {
    path: '',
    component: PagesWrapperComponent,
    children: [
      ...RECOGNITION_ROUTES,
      {
        path: 'text-to-image',
        title: 'Text To Image',
        loadComponent: () =>
          import('../../../text-to-image/text-to-image.component').then(
            (component) => component.TextToImageComponent
          ),
      },
    ],
  },
];
